<div class="preview-page">
  <div class="preview-container">
    <!-- Header -->
    <div class="portal-header">
      <div class="header-kolam"></div>
      <div class="header-inner">
        <div class="brand">
          <div class="brand-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
            </svg>
          </div>
          <div class="brand-text">
            <div class="brand-name">Ash Disposal Portal</div>
            <div class="brand-sub">TNPGCL · Registration Application Preview</div>
          </div>
        </div>
        <a routerLink="/login" class="login-btn">Login</a>
      </div>
    </div>
    <div class="gold-bar"></div>

    <!-- Loading Skeleton -->
    <div *ngIf="loading" class="loading-card">
      <p><i class="bi bi-hourglass-split"></i> Loading registration details...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="!loading && errorMessage" class="error-card">
      <h2>Unable to Load Preview</h2>
      <p style="color: #ef4444; margin-bottom: 15px;">{{ errorMessage }}</p>
      <div *ngIf="applicationNo || referenceNo">
        <p><strong>Application No:</strong> {{ applicationNo || 'N/A' }}</p>
        <p><strong>Reference No:</strong> {{ referenceNo || 'N/A' }}</p>
      </div>
      <button class="login-btn" (click)="loadPreview()"
        style="margin-top: 10px; background: var(--primary); color: white">
        Try Again
      </button>
    </div>

    <ng-container *ngIf="!loading && preview && !errorMessage">
      <!-- Sub-header -->
      <div class="sub-header">
        <div class="reg-label">Registration Application</div>
        <div class="company-row">
          <div>
            <div class="company-name">{{ displayValue(preview.firmName) }}</div>
            <div class="submitted">
              Submitted on {{ formatDate(preview.createdAt || preview.createdDate) }}
            </div>
          </div>
          <div class="status-chip" [ngClass]="statusClass.toLowerCase()">
            <span class="status-chip-dot"></span>
            {{ displayValue(preview.status, 'PENDING') }}
          </div>
        </div>
      </div>

      <!-- Meta strip -->
      <div class="meta-strip">
        <div class="meta-item">
          <div class="meta-label">Application No</div>
          <div class="meta-value mono">{{ displayValue(preview.applicationNo) }}</div>
        </div>
        <div class="meta-item">
          <div class="meta-label">Reference No</div>
          <div class="meta-value mono" style="font-size: 11.5px">
            {{ displayValue(preview.referenceNo) }}
          </div>
        </div>
        <div class="meta-item">
          <div class="meta-label">Power Station</div>
          <div class="meta-value">
            <span class="ps-dot"></span>{{ displayValue(preview.powerStationName) }}
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="content">
        <!-- Application Information -->
        <div class="section-card">
          <div class="section-head">
            <div class="section-icon green">
              <svg viewBox="0 0 24 24">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </div>
            <div class="section-title">Application Information</div>
          </div>
          <div class="fields-grid">
            <div class="field">
              <div class="field-label">Application Number</div>
              <div class="field-value mono bold">{{ displayValue(preview.applicationNo) }}</div>
            </div>
            <div class="field">
              <div class="field-label">Reference Number</div>
              <div class="field-value mono" style="font-size: 11.5px">
                {{ displayValue(preview.referenceNo) }}
              </div>
            </div>
            <div class="field">
              <div class="field-label">Status</div>
              <div class="field-value">
                <span class="status-chip" [ngClass]="statusClass.toLowerCase()">
                  <span class="status-chip-dot"></span>
                  {{ displayValue(preview.status, 'PENDING') }}
                </span>
              </div>
            </div>
            <!-- <div class="field">
              <div class="field-label">Created Date</div>
              <div class="field-value">
                {{ formatDate(preview.createdAt || preview.createdDate) }}
              </div>
            </div> -->
            <!-- <div class="field full">
              <div class="field-label">Power Station Name</div>
              <div class="field-value bold">{{ displayValue(preview.powerStationName) }}</div>
            </div> -->
            <div class="field">
              <div class="field-label">Mobile Number</div>
              <div class="field-value">
                +91 {{ displayValue(preview.mobileNo || preview.mobileNumber) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Station and Type -->
        <!-- <div class="section-card">
          <div class="section-head">
            <div class="section-icon teal">
              <svg viewBox="0 0 24 24">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <div class="section-title">Station and Type</div>
          </div>

          <div class="fields-grid">
            <div class="field">
              <div class="field-label">Mobile Number</div>
              <div class="field-value">
                +91 {{ displayValue(preview.mobileNo || preview.mobileNumber) }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">Power Station Name</div>
              <div class="field-value">
                {{ displayValue(preview.powerStationName) }}
              </div>
            </div>
          </div>
        </div> -->

        <!-- Firm Details -->
        <div class="section-card">
          <div class="section-head">
            <div class="section-icon teal">
              <svg viewBox="0 0 24 24">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <div class="section-title">Firm Details</div>
          </div>

          <div class="fields-grid">
            <div class="field full">
              <div class="field-label">Organization Name</div>
              <div class="field-value bold" style="font-size: 14.5px">
                {{ displayValue(preview.firmName) }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">Email ID</div>
              <div class="field-value">
                {{ displayValue(preview.email || preview.emailAddress) }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">TNEB Tariff Category</div>
              <div class="field-value">
                {{ displayValue(preview.tariffName || preview.tariff) }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">PAN Number</div>
              <div class="field-value mono">
                {{ displayValue(preview.panNo || preview.panNumber) | uppercase }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">GST Number</div>
              <div class="field-value mono">
                {{ displayValue(preview.gstNo || preview.gstNumber) | uppercase }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">MSME Udyam Certificate Type</div>
              <div class="field-value">
                {{ displayValue(preview.msmeUdayamCertificate || preview.msmeCertificateType) }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">MSME Udyam Certificate Number</div>
              <div class="field-value mono">
                {{ displayValue(preview.msmeUdayamNo || preview.msmeRegistrationNumber) }}
              </div>
            </div>

            <div class="field">
              <div class="field-label">TNEB Service Connection Number</div>
              <div class="field-value mono">
                {{ displayValue(preview.tnebScNo || preview.tnpgclScNumber) }}
              </div>
            </div>

            <div class="field no-border">
              <div class="field-label">TNPCB - CTO Certificate</div>
              <div class="field-value">
                {{ displayValue(preview.ctoDetails || preview.consentToOperate) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Address Information -->
        <div class="section-card">
          <div class="section-head">
            <div class="section-icon green">
              <svg viewBox="0 0 24 24">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div class="section-title">Address Information</div>
          </div>

          <div class="fields-grid">
            <!-- Plant Address -->
            <div class="field full">
              <div class="field-label">Plant Address</div>
              <div class="field-value">
                Door No. {{ displayValue(preview.doorNo) }}, Survey Field No.
                {{ displayValue(preview.sfNo || preview.surveyFieldNo) }},
                {{ displayValue(preview.street || preview.streetLocation) }},
                {{ displayValue(preview.villageName || preview.village) }},
                {{ displayValue(preview.talukName || preview.taluk) }},
                {{ displayValue(preview.districtName || preview.district) }},
                {{ displayValue(preview.stateName || preview.state) }}
                - {{ displayValue(preview.pincode) }}
              </div>
            </div>

            <!-- Plant GPS -->
            <div class="field">
              <div class="field-label">Plant GPS Coordinates</div>
              <div class="field-value mono">
                Lat: {{ displayValue(preview.locationLat || preview.latitude) }} | Lng:
                {{ displayValue(preview.locationLng || preview.longitude) }}
              </div>
            </div>

            <!-- Office Address Type -->
            <div class="field">
              <div class="field-label">Office Address Type</div>
              <div class="field-value">
                {{
                preview.isCompanyAddressSameAsPlant
                ? 'Same as Plant Address'
                : 'Different from Plant Address'
                }}
              </div>
            </div>

            <!-- Company Address -->
            <div class="field full" *ngIf="!preview.isCompanyAddressSameAsPlant">
              <div class="field-label">Company Registered Office Address</div>
              <div class="field-value">
                Door No. {{ displayValue(preview.companyDoorNo) }}, Survey Field No.
                {{ displayValue(preview.companySfNo || preview.companySurveyFieldNo) }},
                {{ displayValue(preview.companyStreet || preview.companyStreetLocation) }},
                {{ displayValue(preview.companyVillageName || preview.companyVillage) }},
                {{ displayValue(preview.companyTalukName || preview.companyTaluk) }},
                {{ displayValue(preview.companyDistrictName || preview.companyDistrict) }},
                {{ displayValue(preview.companyStateName || preview.companyState) }}
                - {{ displayValue(preview.companyPincode) }}
              </div>
            </div>

            <!-- Company GPS -->
            <div class="field" *ngIf="!preview.isCompanyAddressSameAsPlant">
              <div class="field-label">Company GPS Coordinates</div>
              <div class="field-value mono">
                Lat: {{ displayValue(preview.companyLocationLat || preview.companyLatitude) }} |
                Lng: {{ displayValue(preview.companyLocationLng || preview.companyLongitude) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Plant Operation -->
        <div class="section-card">
          <div class="section-head">
            <div class="section-icon amber">
              <svg viewBox="0 0 24 24">
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <div class="section-title">Plant Operation</div>
          </div>

          <div class="fields-grid">
            <!-- Plant Machinery -->
            <div class="field">
              <div class="field-label">Plant & Machinery Availability Details</div>
              <div class="field-value">
                <ng-container *ngIf="
                    getMachineryList(preview.plantMachineriesAvailability || preview.plantMachinery)
                      .length;
                    else noMachinery
                  ">
                  <div class="tag-row mt-1">
                    <span class="tag green" *ngFor="
                        let mach of getMachineryList(
                          preview.plantMachineriesAvailability || preview.plantMachinery
                        )
                      ">
                      {{ mach }}
                    </span>
                  </div>
                </ng-container>
                <ng-template #noMachinery>N/A</ng-template>
              </div>
            </div>

            <!-- Ash Unloading Facilities -->
            <div class="field">
              <div class="field-label">Ash Unloading Facilities</div>
              <div class="field-value">
                <ng-container *ngIf="ashUnloadingFacilities.length; else noFacilities">
                  <span *ngFor="let facility of ashUnloadingFacilities; let last = last">
                    {{ getFacilityName(facility) }}{{ !last ? ', ' : '' }}
                  </span>
                </ng-container>

                <ng-template #noFacilities> N/A </ng-template>
              </div>
            </div>

            <!-- Fly Ash Product Type -->
            <div class="field">
              <div class="field-label">Fly Ash Product Type</div>
              <div class="field-value">
                <ng-container *ngIf="ashProducts.length; else noProduct">
                  {{ getProductName(ashProducts[0]) }}
                </ng-container>

                <ng-template #noProduct> N/A </ng-template>
              </div>
            </div>

            <!-- Product Description -->
            <div class="field" *ngIf="ashProducts.length && getProductDescription(ashProducts[0])">
              <div class="field-label">Product Description</div>
              <div class="field-value">
                {{ getProductDescription(ashProducts[0]) }}
              </div>
            </div>

            <!-- Selected Ash Categories -->
            <div class="field full">
              <div class="field-label">Selected Ash Categories</div>

              <div style="overflow-x: auto; margin-top: 10px">
                <table class="doc-table" *ngIf="ashCategories.length">
                  <thead>
                    <tr>
                      <th>Ash Category Name</th>
                      <th>Min Quantity (MT)</th>
                      <th>Max Quantity (MT)</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let cat of ashCategories">
                      <td>
                        {{ getCategoryName(cat) }}
                      </td>

                      <td>
                        {{ cat.minQuantity ?? cat.minQty ?? cat.quantity ?? cat.qty ?? '-' }}
                      </td>
                      <td>
                        {{ cat.maxQuantity ?? cat.maxQty ?? cat.quantity ?? cat.qty ?? '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="empty-section" *ngIf="!ashCategories.length">
                  No ash categories selected.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Uploaded Documents -->
        <div class="section-card">
          <div class="section-head">
            <div class="section-icon blue">
              <svg viewBox="0 0 24 24">
                <path
                  d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
              </svg>
            </div>
            <div class="section-title">Supporting Documents</div>
          </div>

          <div *ngIf="documents.length; else noDocuments" style="overflow-x: auto">
            <table class="doc-table">
              <thead>
                <tr>
                  <th>Document Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of documents">
                  <td>
                    <div class="doc-icon">
                      <div class="doc-icon-circle" [ngClass]="{ pdf: true }">
                        <svg viewBox="0 0 24 24">
                          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                        </svg>
                      </div>
                      <a class="doc-name-link" (click)="viewDocument(doc)">
                        {{ displayValue(doc.documentTypeName, 'Document') }}
                      </a>
                    </div>
                  </td>
                  <td>
                    <div class="doc-actions">
                      <button class="doc-btn view" [disabled]="!getDocId(doc) || isDocLoading(doc)"
                        (click)="viewDocument(doc)">
                        <svg viewBox="0 0 24 24">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>View
                      </button>
                      <button class="doc-btn dl" [disabled]="!getDocId(doc) || isDocLoading(doc)"
                        (click)="downloadDocument(doc)">
                        <svg viewBox="0 0 24 24">
                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>Download
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noDocuments>
            <div class="empty-section">No documents uploaded.</div>
          </ng-template>
        </div>
      </div>

      <!-- Footer -->
      <div class="portal-footer">
        © TNPGCL <span class="footer-brand">Ash Disposal Portal</span>. All rights reserved.
      </div>
    </ng-container>
  </div>
</div>

<!-- Document Preview Modal -->
<div class="custom-modal-backdrop" *ngIf="previewDocumentUrl">
  <div class="custom-modal-content"
    style="max-width: 1400px; width: 95%; height: 95vh; display: flex; flex-direction: column">
    <div class="modal-header d-flex justify-content-between align-items-center py-2 px-3 border-bottom bg-light">
      <h3 class="modal-title mb-0 fs-6 fw-bold">
        <i class="bi bi-file-earmark-text text-primary me-2"></i> Document Preview
      </h3>
      <button class="btn-close-modal" (click)="closeDocumentPreview()" style="
          background: none;
          border: none;
          font-size: 1.2rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          transition: background-color 0.2s;
        " onmouseover="this.style.backgroundColor = '#e9ecef'" onmouseout="this.style.backgroundColor = 'transparent'">
        <i class="bi bi-x-lg text-secondary" style="font-size: 1rem"></i>
      </button>
    </div>
    <div class="modal-body flex-grow-1 p-0" style="position: relative; background: #525659; overflow: hidden; display: flex; align-items: center; justify-content: center;">
      <iframe *ngIf="!previewDocumentIsImage" [src]="previewDocumentUrl" style="width: 100%; height: 100%; border: none; display: block"></iframe>
      <img *ngIf="previewDocumentIsImage" [src]="previewDocumentUrl" style="max-width: 100%; max-height: 100%; object-fit: contain;" />
    </div>
  </div>
</div>